
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-3d5741bf\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./card.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./card.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3d5741bf\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./card.vue"),
  /* scopeId */
  "data-v-3d5741bf",
  /* cssModules */
  null
)
Component.options.__file = "D:\\a\\1\\s\\CutomerAppRazorPrerender\\scripts\\src\\pages\\card.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] card.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3d5741bf", Component.options)
  } else {
    hotAPI.reload("data-v-3d5741bf", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./scripts/src/pages/card.vue
// module id = 747
// module chunks = 0